import { buildProps } from "@xplus/utils/props";
import { useSizeProp } from "@xplus/hooks";
// import { buttonProps } from "element-plus";
import type { ExtractPropTypes } from "vue";
// import type { ButtonProps } from "element-plus";
export const buttonType = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  "text",
  "",
  "minor",
] as const;
export const xButtonProps = buildProps({
  type: {
    type: String,
    default: "",
    values: buttonType,
  },
  size: useSizeProp,
} as const);
// TODO：类型推断的继承问题
export type XButtonProps = ExtractPropTypes<typeof xButtonProps>;
